export default "__VITE_ASSET__ab826780__"